import {
  Box,
  Button,
  Table,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  useDisclosure,
  useToast,
} from "@chakra-ui/react";
import { currencyFormat, DEFAULT_TOAST_DURATION } from "@kg-pos/common";
import { NaikinKyuyoDataFragment, useDeleteNaikinKyuyoMutation } from "__generated__/graphql";
import dayjs from "dayjs";
import { useParams } from "hooks/useParams";
import { useState } from "react";
import { DeleteModal } from "../delete-modal";
import { NaikinKyuyoModal } from "../naikin-kyuyo-modal";

type NaikinKyuyoProps = {
  naikinKyuyos: NaikinKyuyoDataFragment[];
  refetch: any;
};

export const NaikinKyuyo = ({ naikinKyuyos, refetch }: NaikinKyuyoProps) => {
  const id = useParams();
  const [deleteNaikinKyuyo] = useDeleteNaikinKyuyoMutation();
  const naikinKyuyoModal = useDisclosure();
  const [naikinKyuyo, setNaikinKyuyo] = useState<NaikinKyuyoDataFragment | null>(null);
  const toast = useToast();

  const handleDeleteNaikinKyuyo = async (naikinKyuyoId: string): Promise<boolean> => {
    return !!(await deleteNaikinKyuyo({ variables: { id: naikinKyuyoId } })).data
      ?.deleteNaikinKyuyo;
  };

  return (
    <>
      <Box fontWeight="bold" mb={5}>
        内勤給与
        <Button
          ml={3}
          colorScheme="blue"
          onClick={() => {
            setNaikinKyuyo(null);
            naikinKyuyoModal.onOpen();
          }}
        >
          追加
        </Button>
      </Box>

      <Table variant="simple">
        <Thead>
          <Tr>
            <Th>固定給</Th>
            <Th>
              役職手当
              <br />
              売上1
            </Th>
            <Th>
              役職手当
              <br />
              売上2
            </Th>
            <Th>
              役職手当
              <br />
              指名1
            </Th>
            <Th>
              役職手当
              <br />
              指名2
            </Th>
            <Th>適用開始年月</Th>
            <Th>適用終了年月</Th>
            <Th>操作</Th>
          </Tr>
        </Thead>
        <Tbody>
          {naikinKyuyos?.map((naikinKyuyo) => (
            <Tr key={naikinKyuyo.id}>
              <Td>{currencyFormat(naikinKyuyo.koteikyu)}</Td>
              <Td>{currencyFormat(naikinKyuyo.uriage1)}</Td>
              <Td>{currencyFormat(naikinKyuyo.uriage2)}</Td>
              <Td>{currencyFormat(naikinKyuyo.shimei1)}</Td>
              <Td>{currencyFormat(naikinKyuyo.shimei2)}</Td>
              <Td>{dayjs(naikinKyuyo.startMonth).format("YYYY年MM月")}</Td>
              <Td>{!!naikinKyuyo.endMonth && dayjs(naikinKyuyo.endMonth).format("YYYY年MM月")}</Td>
              <Td>
                <Button
                  mr={3}
                  onClick={() => {
                    setNaikinKyuyo(naikinKyuyo);
                    naikinKyuyoModal.onOpen();
                  }}
                >
                  編集
                </Button>
                <DeleteModal
                  title="内勤給与削除"
                  name="内勤給与"
                  buttonText="削除"
                  close={true}
                  handleDelete={async () => {
                    if (await handleDeleteNaikinKyuyo(naikinKyuyo.id)) {
                      toast({
                        title: `削除しました。`,
                        status: "success",
                        duration: DEFAULT_TOAST_DURATION,
                        isClosable: true,
                      });
                    } else {
                      toast({
                        title: `削除に失敗しました。`,
                        status: "error",
                        duration: DEFAULT_TOAST_DURATION,
                        isClosable: true,
                      });
                    }
                    await refetch();
                  }}
                />
              </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
      {naikinKyuyoModal.isOpen && (
        <NaikinKyuyoModal
          isOpen={naikinKyuyoModal.isOpen}
          onClose={naikinKyuyoModal.onClose}
          hostId={id}
          data={naikinKyuyo}
          refetch={refetch}
        />
      )}
    </>
  );
};
